import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "container-custom" }

import { onMounted, onUnmounted, reactive, ref } from "vue";
// LayoutHeader
import LayoutHeader from "@layouts/layout-header.vue";
import HeaderAdmin from "@layouts/components/header-user.vue";
import { LayoutSidebar } from "@layouts/.";

const user = "John Doe";

const logined = false;


export default /*#__PURE__*/_defineComponent({
  __name: 'layout',
  props: {
    isShowSideBar: {},
    isLogin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isShow = ref(true); // Задать значение по умолчанию
const isShowSideBar = ref(props.isShowSideBar ?? true); // Задать значение по умолчанию = props.isShow ?? true; // Задать значение по умолчанию
const isLogin = ref(props.isLogin ?? false); // Задать значение по умолчанию = props.isShow ?? true; // Задать значение по умолчанию
const MyDependency = {
	foo: "bar",
};
const settings = reactive({ theme: "light" });
const windowWidth = ref(window.innerWidth);
// Отслеживаем событие resize
onMounted(() => {
	window.addEventListener('resize', updateWindowWidth);
	updateWindowWidth()
});

// Очищаем слушатель при удалении компонента
onUnmounted(() => {
	window.removeEventListener('resize', updateWindowWidth);
});
const updateWindowWidth = () => {
	
	const isBigest = windowWidth.value < window.innerWidth
	windowWidth.value = window.innerWidth;
	if (windowWidth.value < 991) {
		// if (isBigest) {
		// 	isShow.value = true;
		// 	return
		// }
		isShow.value = false
		return
	}
	isShow.value = true;

};
function onChangeMenu(value: boolean) {
	isShow.value = value;
	isShowSideBar.value = value;
	if (isShowSideBar.value) document.body.style.overflow = "hidden";
	// Блокируем прокрутку
	else {
		document.body.style.overflow = ""; // Восстанавливаем прокрутку
	}
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LayoutHeader, {
      onChangeMenu: _cache[0] || (_cache[0] = ($event: any) => (onChangeMenu($event))),
      show: isShow.value,
      isLogin: isLogin.value
    }, null, 8, ["show", "isLogin"]),
    _createElementVNode("div", _hoisted_2, [
      (isShow.value)
        ? (_openBlock(), _createBlock(_unref(LayoutSidebar), {
            key: 0,
            show: isShow.value,
            onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (onChangeMenu(false)))
          }, null, 8, ["show"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["content", { hideBar: !isShowSideBar.value }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(_component_router_view)
        ])
      ], 2)
    ])
  ]))
}
}

})